"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEventHandlerCallbacks = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Hooks for user interaction events.
 */
class UserEventHandlerCallbacks {
    onEntityRequiresUpdate() {
        // no action required
    }
    onDragStart() {
        return true;
    }
    onDrag() {
        // no action required
    }
    onDragEnd() {
        // no action required
    }
    onPan() {
        // no action required
    }
    onWheel() {
        // no action required
    }
    onPanZoomStart() {
        // no action required
    }
    onPanZoomChange() {
        // no action required
    }
    onClick() {
        // no action required
    }
    onDoubleClick() {
        // no action required
    }
    onHover() {
        // no action required
    }
    onCanvasResized() {
        // no action required
    }
    constructor(listeners) {
        rc_js_util_1._Dictionary.extend(this, listeners);
    }
}
exports.UserEventHandlerCallbacks = UserEventHandlerCallbacks;
//# sourceMappingURL=user-event-handler-callbacks.js.map